export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11138.967e7ee6.jpg";